<template>
  <div id="home-banner" ref="homeBanner">
    <plex-header></plex-header>
    <div class="content" id="home-banner-content">
      <div class="left-banner">
        <div class="trust">
          <img
            v-if="$store.state.currentLang === 'en'"
            src="/static/activityImg/7-day-trust-en.png"
            class="banner-trust h1-pc"
          />
          <img
            v-if="$store.state.currentLang === 'zh'"
            src="/static/activityImg/7-days-trust-zh.png"
            class="banner-trust h1-pc"
          />
          <img
            v-if="$store.state.currentLang === 'en'"
            src="/static/activityImg/7-day-trust-en-h5.png"
            class="banner-trust h1-phone"
          />
          <img
            v-if="$store.state.currentLang === 'zh'"
            src="/static/activityImg/7-day-trust-zh-h5.png"
            class="banner-trust h1-phone"
          />
        </div>
        <div class="banner-title">
          <h1 class="h1-pc" ref="pcTitle">{{ $t("pcTitle[0]") }}</h1>
          <h1 class="h1-pc" ref="pcTitle">{{ $t("pcTitle[1]") }}</h1>
          <h1 class="h1-phone" ref="phoneTitle" v-html="$t('phoneTitle')"></h1>
          <div class="description" v-html="$t('bannerDes')"></div>
        </div>
        <div class="banner-btn">
          <router-link
            :to="!hasToken ? '/register' : '/dashboard'"
            class="get-plex"
            >{{ $t("signUp") }}</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlexHeader from "../../../components/plexHeader/mainHeader/Index.vue";
import locales from "./lang";
import { mapState } from "vuex";

export default {
  name: "home-banner",
  components: { PlexHeader },
  locales,
  computed: {
    ...mapState({
      hasToken: (state) => state.hasToken,
    }),
  },
  created: function () {
    this.$store.commit("setTrackEventLabel", "Home page register form");
    this.$store.commit("resetDefaultActiveLink");
    this.$store.commit("setDefaultActiveLink", "home");
    this.$store.commit("isSpecialHeader", true);
  },
  mounted() {
    this.$store.commit("isSpecialHeader", true);
  },
  destroyed() {
    this.$store.commit("isSpecialHeader", false);
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../assets/scss/variables";
@import "../../../assets/scss/mixins/button";
@import "../../../assets/scss/formstyle";
@import "../../../assets/scss/mixins/gradient.scss";
@import "../../../assets/scss/activity.scss";

* {
  margin: 0;
  padding: 0;
}

#home-banner {
  position: relative;
  @include gradient-background(
    $deg: 90deg,
    $bottom-color: rgba(91, 104, 249, 0.9) 10%,
    $top-color: rgba(202, 89, 254, 0.9) 100%
  );
  padding: 0;
  width: 100%;
  height: 100vh;
  z-index: 11;
  background: url("~/static/activityImg/pc_banner.png") 100% 100% no-repeat;
  background-size: 100% 100%;
}

#home-banner-content {
  position: relative;
  margin: 0 auto;
  max-width: 11.8rem;
  height: 100%;
  text-align: start;
  color: #111111;
  .left-banner {
    width: 870px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    .trust {
      margin-bottom: 32px;
      .banner-trust {
        height: 36px;
        object-fit: contain;
      }
    }
    .banner-title {
      margin-bottom: 44px;
      .h1-pc {
        font-size: 58px;
        color: #111111;
        letter-spacing: 0;
        line-height: 68px;
        font-weight: 600;
      }
      .description {
        font-size: 24px;
        color: #666666;
        letter-spacing: 1px;
        line-height: 36px;
        font-weight: 500;
        margin-top: 16px;
      }
    }
    .banner-btn {
      .get-plex {
        display: block;
        width: 350px;
        height: 66px;
        line-height: 66px;
        background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
        border-radius: 100px;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        font-weight: 600;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: 8px;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
          border-radius: 100px;
          filter: blur(8px);
          -webkit-filter: blur(8px);
          -moz-filter: blur(8px);
          -ms-filter: blur(8px);
          -o-filter: blur(8px);
          z-index: -1;
        }
      }
    }
  }

  .sign-up-box {
    display: block;
    width: 3rem;
    height: 0.66rem;
    background-size: 100% 100%;
    line-height: 0.66rem;
    text-align: center;
    margin: 0 auto;
    margin-top: 0.62rem;
    color: rgba(255, 255, 255, 1);
    font-family: "SF UI Display";
    font-size: 24px;
    letter-spacing: 1.4px;
    background-image: url("~/static/activityImg/banner_btn_default.png");
    &:hover {
      background-image: url("~/static/activityImg/banner_btn_hover.png");
    }
  }

  .sign-up-btn {
    display: inline-block;
    z-index: 99;
    color: #fff;
    padding: 0;
    font-size: 0.24rem;
    height: 0.66rem;
    min-width: 2.6rem;
    margin: 0.6rem auto 0.4rem auto;
  }
  .register-awards {
    font-size: 0.18rem;
  }
  .banner-logo-activity {
    width: 303px;
    height: 261px;
    object-fit: contain;
  }
}

.top-n {
  position: absolute;
  top: 0.7rem;
  left: 50%;
  transform: translateX(-50%);
  width: 1.89rem;
}

@media (max-width: 767px) {
  // #home-banner-content {
  //   height: 4.3rem;
  //   h1 {
  //     font-size: 0.24rem;
  //     line-height: 0.4rem;
  //     padding: 0 0.16rem;
  //   }
  //   .sign-up-box {
  //     background-size: 75% 75%;
  //     background-repeat: no-repeat;
  //     background-position: center;
  //     font-size: 15px;
  //   }
  //   .sign-up-btn {
  //     border: 0;
  //     color: #fff;
  //     font-size: 0.2rem;
  //     padding: 0 0.4rem;
  //     margin: 0.25rem auto 0.15rem auto;
  //   }
  //   .register-awards {
  //     font-size: 0.14rem;
  //   }
  //   .banner-logo-activity {
  //     width: 168px;
  //     height: 161px;
  //   }
  // }

  .top-n {
    top: 0.6rem;
    width: 0.82rem;
  }
}

@media (max-width: 1228px) {
  #home-banner #home-banner-content .left-banner {
    left: 24px;
  }
}

@media (width: 1024px) and (height: 1366px) {
  #home-banner {
    height: 700px;
  }
}

@media (max-width: 991px) {
  .h1-phone {
    display: block;
  }
  .h1-pc {
    display: none;
  }
  #home-banner {
    height: 550px;
    background-image: url("~/static/activityImg/mobile_ banner.png");
    #home-banner-content {
      max-width: 100%;
      text-align: center;
      .left-banner {
        max-width: 100%;
        width: 310px;
        margin: 0 auto;
        top: 50px;
        left: 0;
        transform: none;
        .trust {
          padding-top: 44px;
          margin-bottom: 48px;
          .banner-trust {
            width: 220px;
            height: auto;
            margin: 0 auto;
          }
        }
        .banner-title {
          margin-bottom: 84px;
          h1 {
            font-size: 32px;
            line-height: 40px;
            font-weight: 700;
          }
          .h1-phone {
            margin-bottom: 24px;
          }
          .description {
            font-size: 14px;
            color: #111111;
            letter-spacing: 1px;
            text-align: center;
            line-height: 20px;
            font-weight: 400;
          }
        }
        .banner-btn {
          .get-plex {
            width: 260px;
            height: 49px;
            line-height: 49px;
            font-size: 16px;
            margin: 0 auto;
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .h1-phone {
    display: none;
  }
  .h1-pc {
    display: block;
  }
}

@media (max-width: 767px) {
  #home-banner #home-banner-content .left-banner {
    width: 100%;
    padding: 0 24px;
    left: 0;
  }
}

.snow-container {
  position: absolute;
  height: 100%;
  width: 100%;
  max-width: 100%;
  top: 0;
  overflow: hidden;
  z-index: -1;
  pointer-events: none;
}

.snow {
  display: block;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
  -webkit-animation: snow linear infinite;
  animation: snow linear infinite;
}
.snow.foreground {
  background-image: url("https://dl6rt3mwcjzxg.cloudfront.net/assets/snow/snow-large-075d267ecbc42e3564c8ed43516dd557.png");
  -webkit-animation-duration: 15s;
  animation-duration: 15s;
}
.snow.foreground.layered {
  -webkit-animation-delay: 7.5s;
  animation-delay: 7.5s;
}
.snow.middleground {
  background-image: url(https://dl6rt3mwcjzxg.cloudfront.net/assets/snow/snow-medium-0b8a5e0732315b68e1f54185be7a1ad9.png);
  -webkit-animation-duration: 20s;
  animation-duration: 20s;
}
.snow.middleground.layered {
  -webkit-animation-delay: 10s;
  animation-delay: 10s;
}
.snow.background {
  background-image: url(https://dl6rt3mwcjzxg.cloudfront.net/assets/snow/snow-small-1ecd03b1fce08c24e064ff8c0a72c519.png);
  -webkit-animation-duration: 30s;
  animation-duration: 30s;
}
.snow.background.layered {
  -webkit-animation-delay: 15s;
  animation-delay: 15s;
}

@-webkit-keyframes snow {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    -webkit-transform: translate3d(15%, 100%, 0);
    transform: translate3d(15%, 100%, 0);
  }
}

@keyframes snow {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    -webkit-transform: translate3d(15%, 100%, 0);
    transform: translate3d(15%, 100%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// HomeBanner.vue?44309f4f